export default "__VITE_ASSET__DnMXhvjr__"